<template>
  <div>
    <!--<div class="overlayLoad"></div>-->
    <v-content>
      <v-container fluid>
        <v-flex xs3 v-if="vendorsIni != 0">
          <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
        </v-flex>
        <v-data-table v-if="vendorsIni != 0"  :headers="headers" :search="search" :items="vendorManufacturerLinks" class="elevation-1" :rows-per-page-items="[20,40,60,80,100]">
          <template slot="items" slot-scope="props">
            <td width="50%" class="text-xs-right">{{ props.item.name }}</td>
            <td width="25%" class="text-xs-right"><v-text-field @keyup="fncCheck($event.target.value, props.index, 'reference')" label="Reference / Account Number" v-model="props.item.setReference" single-line solo></v-text-field></td>
            <td width="25%" class="text-xs-right"><v-text-field @keyup="fncCheck($event.target.value, props.index, 'email')" label="Email Address Override" v-model="props.item.email" single-line solo></v-text-field></td>
          </template>
        </v-data-table>
        <p v-if="vendorsIni == 0">Please initiate the Vendors for this MyOrder Instance</p>
        <v-btn v-if="vendorsIni == 0" @click.prevent="fncIniVendors" class="elevation-5" color="info"><i class="material-icons">add</i>Initiate Vendors</v-btn>
      </v-container>
    </v-content>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';

  export default {
	name: 'RoleList',
	intRoleEdit: 0,
    data () {
		return {
			search: '',
            headers: [
              { text: 'Name', value: 'name', width: '50%' },
              { text: 'Reference', value: 'reference', width: '25%' },
              { text: 'Email', value: 'created_on', width: '25%' }
            ],
          vendorListFinal: [],
          loaded: false
		}
	},
    methods: {
      fncIniVendors() {
        this.$store.dispatch('fncIniVendors');
      },
      fncCheck(value, index, type) {
        this.$store.commit({
          type: 'fncUpdateVendorLink',
          value: value,
          index: index,
          ctype: type
        })
      },
      fncDeleteLink( linkId, linkName ) {
        var removeLink = confirm('Are you sure you want to remove the link for '+linkName+'?');
        if (removeLink === true) {
          this.$store.dispatch({
            type: 'fncRemoveVendorLink',
            linkId: linkId,
          })
        }
      },
      fncShowEdit(objVendor, vendorName) {
        this.$store.dispatch({
          type: 'fncSetVendorSelectEdit',
          vendor: vendorName,
          objVendor: objVendor
        })
      }
	},
	computed: {
      ...mapGetters([
            'objAuthorize',
			      'userRoles',
            'vendorManufacturerLinks',
            'vendorList',
            'vendorsIni'
		])
	},
    beforeMount() {
      this.$store.dispatch('fncPopulateVendorLinks');
      this.$store.dispatch('fncPopulateVendors');
      this.$store.dispatch('fncGetAppRanges');
	}
}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>
